import { render } from "./GoalForm.vue?vue&type=template&id=9ae0ca72"
import script from "./GoalForm.vue?vue&type=script&lang=js"
export * from "./GoalForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__